import type { DocumentCategory } from '@libs/services/models';
import { DOCUMENTS_CATEGORY_QUERY_PARAM, DOCUMENTS_ROUTE_PATH, NavModel, NavItemModel } from '@libs/shared/models';

export const AccountDocumentNavItems: Record<DocumentCategory, NavItemModel> = {
  planograms: {
    label: 'Meine Planogramme',
    description: 'Planogramme einsehen und herunterladen',
    url: `/${DOCUMENTS_ROUTE_PATH}`,
    queryParams: { [DOCUMENTS_CATEGORY_QUERY_PARAM]: 'planograms' },
    icon: {
      family: 'light',
      name: 'table-layout',
    },
  },
  catalogs: {
    label: 'Meine Kataloge',
    description: 'Aktionsmagazine und Kataloge durchblättern',
    url: `/${DOCUMENTS_ROUTE_PATH}`,
    queryParams: { [DOCUMENTS_CATEGORY_QUERY_PARAM]: 'catalogs' },
    icon: {
      family: 'light',
      name: 'newspaper',
    },
  },
};

const EmployeeNavItem: NavItemModel = {
  label: 'Meine Mitarbeiter',
  description: 'Mitarbeiter-Accounts einladen und verwalten',
  url: 'employees',
  icon: {
    family: 'light',
    name: 'users',
  },
};

const AccountNavigationChildren: NavItemModel[] = [
  {
    label: 'Meine Kundendaten',
    description: 'Kundendaten einsehen und ändern',
    url: 'customers',
    icon: {
      family: 'light',
      name: 'store',
    },
  },
  {
    label: 'Meine Benutzerdaten',
    description: 'Benutzerdaten einsehen und ändern',
    url: 'user',
    icon: {
      family: 'light',
      name: 'user-lock',
    },
  },
  {
    label: 'Meine E-Mail-Adressen',
    description: 'E-Mail-Adressen einsehen und ändern',
    url: 'email',
    icon: {
      family: 'light',
      name: 'mailbox-open-letter',
    },
  },
];

export const AccountNavigation: NavModel = {
  title: 'My Account',
  name: 'primary',
  children: AccountNavigationChildren,
};

export const AccountMainUserNavigation: NavModel = {
  ...AccountNavigation,
  children: [...AccountNavigationChildren, EmployeeNavItem],
};
